import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Card, Typography, Alert, Input, Button, Form } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { useAuth } from '../context/AuthContext';

const { Title, Text } = Typography;

const LoginContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
`;

const LoginCard = styled(Card)`
  width: 420px;
  text-align: center;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
`;

const Logo = styled.div`
  font-size: 48px;
  margin-bottom: 16px;
`;

export function Login() {
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const from = (location.state as any)?.from?.pathname || '/';

  useEffect(() => {
    if (isAuthenticated) {
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, navigate, from]);

  const handleLogin = async (values: { username: string; password: string }) => {
    setIsLoggingIn(true);
    setError(null);

    try {
      await login(values.username, values.password);
      navigate(from, { replace: true });
    } catch (err: any) {
      const errorMessage =
        err.response?.data?.message || err.message || 'Kirish xatolik';
      setError(errorMessage);
    } finally {
      setIsLoggingIn(false);
    }
  };

  if (isAuthenticated) {
    return null;
  }

  return (
    <LoginContainer>
      <LoginCard>
        <Logo>🚗</Logo>
        <Title level={2}>Moshina Bozor</Title>
        <Title level={4} style={{ fontWeight: 400, color: '#666' }}>
          Admin Panel
        </Title>

        {error && (
          <Alert
            message="Xatolik"
            description={error}
            type="error"
            showIcon
            style={{ marginBottom: 16, textAlign: 'left' }}
          />
        )}

        <Form onFinish={handleLogin} layout="vertical" style={{ textAlign: 'left' }}>
          <Form.Item
            name="username"
            rules={[{ required: true, message: 'Username kiriting' }]}
          >
            <Input
              size="large"
              prefix={<UserOutlined />}
              placeholder="Username"
            />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Parol kiriting' }]}
          >
            <Input.Password
              size="large"
              prefix={<LockOutlined />}
              placeholder="Parol"
            />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              block
              loading={isLoggingIn}
            >
              Kirish
            </Button>
          </Form.Item>
        </Form>

        <Text type="secondary" style={{ fontSize: 12 }}>
          Faqat adminlar kirishi mumkin
        </Text>
      </LoginCard>
    </LoginContainer>
  );
}
